import { computeArchetype, loadProfileLocal } from "@/components/assessment/assessmentScoring";

export function getSavedAssessment() {
  const saved = loadProfileLocal();
  if (!saved?.a) return null;
  const computed = computeArchetype(saved.a);
  const nervousSystemProfile =
    saved.nervousSystemProfile || saved.a.robustProfile || computed.nervousSystemProfile || null;
  const profile = nervousSystemProfile
    ? {
        key:
          saved.profileKey ||
          nervousSystemProfile.legacyProfileKey ||
          computed.key,
        title: nervousSystemProfile.headline,
        body: nervousSystemProfile.bottomLine,
        nervousSystemProfile,
        userFacingType: "descriptive-nervous-system-profile",
      }
    : computed;

  return {
    id: saved.id || null,
    schemaVersion: Number(saved.v) || 0,
    assessmentModel: saved.assessmentModel || null,
    answers: saved.a,
    identity: saved.i || null,
    profile,
    baselineVector:
      saved.baselineVector || nervousSystemProfile?.vector || null,
    nervousSystemProfile,
    completedAt: saved.t,
  };
}
